<template>
    <div
        class="group relative grid appearance-none grid-flow-row auto-rows-min grid-cols-[1fr_1fr_5rem] items-stretch justify-between gap-x-6 gap-y-4 rounded-md border-2 p-4 text-left transition-all sm:grid-cols-[1fr_1fr_9rem] sm:p-6"
        :class="{
            'cursor-not-allowed border-gray-300 opacity-60': !isAvailable && webshopSettings().hasDispatchTypes,
            'cursor-pointer border-gray-200 active:border-gray-500 sm:hover:scale-[102%] sm:hover:bg-gray-100': isAvailable && webshopSettings().hasDispatchTypes,
            'cursor-default': !webshopSettings().hasDispatchTypes
        }"
        role="button"
        @click="openProduct()"
    >
        <client-only class="absolute -right-3 -top-3">
            <transition name="scale">
                <span v-if="getCartQuantityForProduct(id) > 0" class="absolute -right-3 -top-3 size-6 rounded-full bg-primary text-center text-xs font-bold leading-6 text-white shadow">{{ getCartQuantityForProduct(id) }}</span>
            </transition>
        </client-only>
        <div class="flex flex-col gap-4" :class="image && image.path ? 'col-span-2' : 'col-span-3'">
            <ProductHeader v-bind="props" context="product" />
            <div v-if="description || extras?.length" class="flex flex-col gap-2">
                <p v-if="description" class="text-xs font-bold text-gray-500 sm:text-sm" v-html="description" />
                <ProductExtrasLabel :description-extras="descriptionExtras" :extras="extras" />
            </div>
        </div>
        <ProductImage :image="image" />
        <div class="col-span-3 flex items-center gap-4" :class="image && image.path ? 'col-span-3 md:col-span-2' : 'col-span-3'">
            <div class="flex items-center gap-4">
                <span class="min-w-20">
                    <ProductPriceButton v-bind="props" :is-available="isAvailable" :product-maximum-reached="productMaximumReached(props)" />
                </span>
                <ProductOriginalPrice v-if="originalPrice" :original-price="originalPrice" />
            </div>
            <Allergies v-if="allergies" :id="id" :allergies="allergies" class="text-primary" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
    import Allergies from '~/components/Allergies.vue'
    import ProductExtrasLabel from '~/components/Product/ProductExtrasLabel.vue'
    import ProductHeader from '~/components/Product/ProductHeader.vue'
    import ProductImage from '~/components/Product/ProductImage.vue'
    import ProductOriginalPrice from '~/components/Product/ProductOriginalPrice.vue'
    import ProductPriceButton from '~/components/Product/ProductPriceButton.vue'
    import { getCartQuantityForProduct, productIsAvailable } from '~/composables/productLimitations'
    import { cart } from '~/store/cart'
    import { productForm } from '~/store/productForm'
    import { webshopSettings } from '~/store/webshopSettings'
    // TODO: abstract into multiple other components
    import { ProductAvailabilityOrderBuddy } from '~/types/orderbuddy-types'
    const props = defineProps<ProductOrderBuddy>()
    const isMounted = ref(false)
    // eslint-disable-next-line unused-imports/no-unused-vars
    const allAllergies = [ 'wheat', 'gluten', 'shellfish', 'eggs', 'fish', 'peanuts', 'soy', 'milk', 'nut', 'celery', 'mustard', 'sesame', 'so2', 'lupine', 'molluscs', 'vegetarian', 'vegan', 'veggan', 'no_gluten', 'halal', 'azo', 'bio', 'coconut', 'no_lactose', 'pig', 'crab', 'alcohol' ]
    function openProduct () {
        if (productIsAvailable(props) && webshopSettings().hasDispatchTypes) {
            if (Object.keys(props).length && Object.keys(props.extras).length) {
                productForm().openModalFromProduct(props)
            } else {
                cart().addProduct({
                    id: props.id,
                    price: props.price,
                    quantity: 1
                })
            }
        }
    }
    onMounted(async () => {
        isMounted.value = true
    })
    const isAvailable = computed(() => (!isMounted.value && props.available === ProductAvailabilityOrderBuddy.AVAILABLE) || (isMounted.value && productIsAvailable(props)))
</script>
